import type { ReactNode, TdHTMLAttributes, ThHTMLAttributes } from 'react';

// Table root
function TableRoot({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div className={`overflow-x-auto ${className}`}>
      <table className="min-w-full divide-y divide-surface-200">{children}</table>
    </div>
  );
}

// Table.Head
function Head({ children }: { children: ReactNode }) {
  return <thead className="bg-surface-50">{children}</thead>;
}

// Table.Body
function Body({ children }: { children: ReactNode }) {
  return <tbody className="divide-y divide-surface-200 bg-white">{children}</tbody>;
}

// Table.Row
function Row({
  children,
  onClick,
  className = '',
}: {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}) {
  return (
    <tr
      onClick={onClick}
      className={`${onClick ? 'cursor-pointer hover:bg-surface-50' : ''} ${className}`}
    >
      {children}
    </tr>
  );
}

// Table.Header
function Header({
  children,
  className = '',
  ...props
}: ThHTMLAttributes<HTMLTableCellElement> & { children?: ReactNode }) {
  return (
    <th
      className={`px-4 py-3 text-left text-xs font-medium text-surface-500 uppercase tracking-wider ${className}`}
      {...props}
    >
      {children}
    </th>
  );
}

// Table.Cell
function Cell({
  children,
  className = '',
  ...props
}: TdHTMLAttributes<HTMLTableCellElement> & { children?: ReactNode }) {
  return (
    <td className={`px-4 py-3 text-sm text-surface-700 ${className}`} {...props}>
      {children}
    </td>
  );
}

export const Table = Object.assign(TableRoot, { Head, Body, Row, Header, Cell });
